import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.scss']
})
export class GameComponent {
   id: string = "";
   game_type: string = ""
    constructor(private route: ActivatedRoute){
      
    }
  
    ngOnInit(): void {
      this.route.paramMap
      .subscribe(params => {
        this.id = params.get("id")??"";
        this.game_type = this.route.snapshot.queryParamMap.get("game_type")??""
      })
    }
}
